import {
  FETCH_LIST_ALL_DELETED_COMPANIES_REQUEST,
  FETCH_LIST_ALL_DELETED_COMPANIES_SUCCESS,
  FETCH_LIST_ALL_DELETED_COMPANIES_FALUIRE,
  SEARCH_DELETED_COMPANIES
} from './listDeletedCompanyTypes'

const initialState = {
  loading: false,
  allDeletedCompany: null,
  allDelCompanyF:null,
  error: '',
}

const reducer = (state = initialState, action) => {

  switch (action.type) {
    case FETCH_LIST_ALL_DELETED_COMPANIES_REQUEST : return {
      ...state,
      loading: true,

    }

    case FETCH_LIST_ALL_DELETED_COMPANIES_SUCCESS : return {
      ...state,
      allDeletedCompany: action.payload,
      allDelCompanyF:action.payload,
      error: '',
      loading: false,
    }

    case FETCH_LIST_ALL_DELETED_COMPANIES_FALUIRE : return {
      ...state,
      loading: false,
      allDeletedCompany: null,
      allDelCompanyF:null,
      error: action.payload,
    }
    case SEARCH_DELETED_COMPANIES: return {
      ...state,     
      allDeletedCompany: state?.allDelCompanyF?.filter((data)=> data?.name?.toLowerCase()?.includes(action?.payload?.toLowerCase()))     
    }
    default : return state
  }
}

export default reducer
